import moment from "moment";

export const titleCase = (str) => {
    return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() });
}

export const getNameFromEmail = (email) => {
  const name = email.match(/^([^@]*)@/);
  return titleCase(name ? name[1].split('.').join(' ') : '');
}

export const copyTextToClipboard = async (text) => {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    let textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
    });
  }
}

 /* *** function for abbrivating categories defined in the deal-sense app ( below ) *** */
 export const abbrivateCategories = (category) => {
  let abbrivation = '';
  switch(category){
    case 'Documents to be uploaded':
      abbrivation = 'TBU';
    break;
    case 'Borrowers/Company Filing do not exist in Loan Connector':
      abbrivation = 'NF-LC';
    break;
    case 'Less than 25M':
      abbrivation = 'LT-25M';
    break;
    case 'Press Release':
      abbrivation = 'PR';
    break;
    case 'Questions':
      abbrivation = 'QTN';
    break;
    case 'Draft':
      abbrivation = 'DRFT';
    break;
    default:
      abbrivation = false;
    break;
  }
  return abbrivation;
}

/* *** get category short name by full name *** */
export const categoryShortHand = (category)=> {
  let abbrivation = '';
  switch(category){
    case 'TBU':
      abbrivation = 'Documents to be uploaded';
    break;
    case 'NF-LC':
      abbrivation = 'Borrowers/Company Filing do not exist in Loan Connector';
    break;
    case 'LT-25':
      abbrivation = 'Less than 25M';
    break;
    case 'PR':
      abbrivation = 'Press Release';
    break;
    case 'QTN':
      abbrivation = 'Questions';
    break;
    case 'DRFT':
      abbrivation = 'Draft';
    break;
    default:
      abbrivation = false;
    break;
  }
  return abbrivation;
}

  /* *** check if the day is a monday or else ( below ) *** */
  export const isHoliyday = (filedAt) =>{
    let date = moment(filedAt).format("YYYY-MM-DD");
    let day = moment(date).format("dddd");
    if(day === 'Saturday'){
      return 1;
    }  else if(day === "Sunday"){
      return 2;
    }
    return -1;
  }

  /* *** get columns names *** */
  export const abbrivateFilingColumns = (api_labels) => {
    let abbrivation = '';
    switch(api_labels){
      case 'SR.':
        abbrivation = 'SR.';
      break;
      case 'filing_date':
        abbrivation = 'Filing Date';
      break;
      case 'company_name':
        abbrivation = 'Company Filing Name';
      break;
      case 'borrower_name':
        abbrivation = 'Borrower Name';
      break;
      case 'cik_number':
        abbrivation = 'CIK Number';
      break;
      case 'film_number':
        abbrivation = 'Film Num';
      break;
      case 'ejv_id':
        abbrivation = 'EJV ID';
      break;
      case 'ejv_date':
        abbrivation = 'Date EJV ID was re-checked to the BLUES';
      break;
      case 'form_type':
        abbrivation = 'Form Type';
      break;
      case 'exhibit':
        abbrivation = 'Exhibit';
      break;
      case 'title_name':
        abbrivation = 'Title Name';
      break;
      case 'agreement_type':
        abbrivation = 'Agreement Type (O, A, A&R, Warrant or Waiver)';
      break;
      case 'signing_date':
        abbrivation = 'Signing Date';
      break;
      case 'prev_amend_date':
        abbrivation = 'Previous Date being Amended';
      break;
      case 'amend_numb':
        abbrivation = 'Amendment number';
      break;
      case 'loan_amount':
        abbrivation = 'Loan $$ Amount (only needed for O, A/R)';
      break;
      case 'book_runner':
        abbrivation = 'Lead Arranger/Bookrunner';
      break;
      case 'loan_exists_lc':
        abbrivation = 'Does Loan Exist in Loan Connector';
      break;
      case 'lc_deal_id':
        abbrivation = 'Loan Connector Deal ID';
      break;
      case 'borrower_exists_lc':
        abbrivation = 'Does Borrower Exist in Loan Connector?';
      break;
      case 'filing_entry_exists_lc':
        abbrivation = 'Does Filing Entity exist in Loan Connector?';
      break;
      case 'loan_doc_num':
        abbrivation = 'Loan Doc #';
      break;
      case 'doc_capture_date':
        abbrivation = 'Date document was captured from SEC';
      break;
      case 'doc_upload_lc_date':
        abbrivation = 'Date doc was uploaded to Loan Connector';
      break;
      case 'filing_url':
        abbrivation = 'Filing URL';
      break;
      case 'sec_url':
        abbrivation = 'SEC.gov URL';
      break;
      case 'analyst_name_who_recorded':
        abbrivation = 'Analyst who recorded the document';
      break;
      case 'analyst_name_who_upload':
        abbrivation = 'Analyst who uploaded the document to Loan Connector';
      break;
      case 'filing_review_date':
        abbrivation = 'Date the filing was reviewed in Loan Connector for company presence';
      break;
      case 'pixeledge_comment':
        abbrivation = 'PixelEdge Comment';
      break;
      case 'refinitive_comment':
        abbrivation = 'Refinitiv Comment';
      break;

      default:
        abbrivation = false;
      break;
    }
    return abbrivation;
  }  
  
    /* *** below method will execute a regex to match searched value *** */
    export const searchAndHighlight = (htmlContent = "", searchStream=[], containerId) => {
      if (searchStream.length === 0) return htmlContent;
    
      // Parse the HTML content into a DOM structure
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');

      searchStream.forEach(query => {
        if(query !== ""){

          // Normalizing whitespace and escape special characters in the searchStream
          const escapedSearchStream = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s*');
          const regex = new RegExp(escapedSearchStream, 'gi');
      
          const highlightText = (node) => {
            if ((node.nodeType === Node.TEXT_NODE) && (node.textContent.trim() !== "") && (node.tagName !== 'IMG')) {
              const textContent = node.textContent;
              if (regex.test(textContent)) {
                const newNode = document.createElement('span');
                newNode.innerHTML = textContent.replace(regex, (matched) => `<mark class="mark-highlight">${matched}</mark>`);
                node.parentNode.replaceChild(newNode, node);
              }
            } else if ((node.nodeType === Node.ELEMENT_NODE) && (node.tagName !== 'IMG')) {
              node.childNodes.forEach(highlightText);
            }
          };
      
          highlightText(doc.body);
        }
      });
    
      // Scroll to the first occurrence
      setTimeout(() => {
        const container = document.querySelector('document');
        if (container) {
          const markElement = container.querySelector('mark');
          if (markElement) {
            markElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            console.warn("No highlight marks found in the container.");
          }
        } else {
          console.error(`Container with ID ${containerId} not found.`);
        }
      }, 0);
    
      // Serialize the modified DOM back to a string
      return doc.body.innerHTML;
    };

  /* *** loan Date format function *** */
  export const formatDate = (date) => {
    const formatter = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
    return formatter.format(date);
  };

  /* *** check either data is a valid json object *** */
  export const isValidJSON = (data)=> {
    try {
      JSON.parse(data);
      return true;
    } catch (error) {
      return false;
    }
  }

  /* *** get document size *** */
  export const documentSize = (sizeInBytes)=> {
    if (sizeInBytes < 1024) {
        return `${sizeInBytes} Bytes`;
    } else if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    } else if (sizeInBytes < 1024 * 1024 * 1024) {
        return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    } else {
        return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
}